import React, { useState } from "react";
import Header from "../components/Header";
import Header2 from "../components/Header2";
import Footer from "../components/Footer";

import "../assets/css/bootstrap.min.css";
import "../assets/css/style.css";
import "../assets/css/menu.css";
import "../assets/css/vendors.css";
import "../assets/css/icon_fonts/css/all_icons_min.css";
import "../assets/css/custom.css";

const doctorsData = [
  {
    name: "Dr. Priya Sharma",
    qualification: "MBBS, MS - Orthopedics, Fellowship in Sports Medicine",
    fee: " FREE Consultation",
    rating: "4.8/5",
    experience: "15 Years Experience",
    location: "2nd Floor, MS Tower, Banjara Hills, Hyderabad",
    phone: "080-6541-7705",
    online: true,
    image: "/assets/img/doctors/doctor1.jpg",
    specialization: "Meniscus Tear Specialist"
  },
  {
    name: "Dr. Anjali Mehta",
    qualification: "MBBS, MS - Orthopedics, Fellowship in Arthroscopy",
    fee: " FREE Consultation",
    rating: "4.9/5",
    experience: "12 Years Experience",
    location: "Apurupa Urban, No 201, 2nd Floor, Image Gardens Rd, near Chirec School, Hyderabad",
    phone: "080-6541-7705",
    online: true,
    image: "/assets/img/doctors/doctor2.jpg",
    specialization: "Knee Arthroscopy Expert"
  },
  {
    name: "Dr. Rohan Verma",
    qualification: "MBBS, MS - Orthopedics, MCh - Sports Medicine",
    fee: " FREE Consultation",
    rating: "4.7/5",
    experience: "14 Years Experience",
    location: "Annapurna Kalyana Mandapam Srinagar Nagar, Dilsukhnagar, Hyderabad",
    phone: "080-6541-7705",
    online: true,
    image: "/assets/img/doctors/doctor1.jpg",
    specialization: "Advanced Meniscus Repair Expert"
  },
  {
    name: "Dr. Sneha Reddy",
    qualification: "MBBS, MS - Orthopedics, Fellowship in Joint Preservation",
    fee: " FREE Consultation",
    rating: "4.6/5",
    experience: "11 Years Experience",
    location: "123 Green Avenue, Banjara Hills, Hyderabad",
    phone: "080-6541-7710",
    online: false,
    image: "/assets/img/doctors/doctor2.jpg",
    specialization: "Non-Surgical Knee Treatment Specialist"
  },
  {
    name: "Dr. Kavita Patel",
    qualification: "MBBS, MS - Orthopedics, Fellowship in Sports Surgery",
    fee: " FREE Consultation",
    rating: "4.8/5",
    experience: "16 Years Experience",
    location: "45 Tower Road, Jubilee Hills, Hyderabad",
    phone: "080-6541-7720",
    online: true,
    image: "/assets/img/doctors/doctor1.jpg",
    specialization: "Meniscus Preservation Expert"
  },
  {
    name: "Dr. Arjun Kumar",
    qualification: "MBBS, DNB - Orthopedics",
    fee: "FREE Consultation",
    rating: "4.7/5",
    experience: "13 Years Experience",
    location: "21 MG Road, Hyderabad",
    phone: "080-6541-7730",
    online: false,
    image: "/assets/img/doctors/doctor2.jpg",
    specialization: "Knee Injury Treatment Specialist"
  },
];

const DoctorsSection = () => {
  const [showAll, setShowAll] = useState(false);
  const displayedDoctors = showAll ? doctorsData : doctorsData.slice(0, 6);

  return (
    <div style={{ padding: "80px 20px", backgroundColor: "#f8f9fa" }}>
      <div style={{ maxWidth: "1200px", margin: "0 auto", fontFamily: "'Poppins', sans-serif" }}>
        <div style={{ textAlign: "center", marginBottom: "50px" }}>
          <h2 style={{ fontSize: "42px", fontWeight: "800", color: "#0b1c39", marginBottom: "15px" }}>
            Our <span style={{ color: "#ffcb24" }}>Meniscus Tear Specialists</span>
          </h2>
          <p style={{ fontSize: "18px", color: "#555", maxWidth: "600px", margin: "0 auto", lineHeight: "1.8" }}>
            Expert care for meniscus tears with 90% success rate. Advanced arthroscopic repair and preservation techniques for knee recovery.
          </p>
        </div>

        <div style={{ display: "flex", flexWrap: "wrap", gap: "25px", justifyContent: "space-between" }}>
          {displayedDoctors.map((doc, index) => (
            <div
              key={index}
              style={{
                flex: "0 0 calc(33.33% - 17px)",
                backgroundColor: "#fff",
                borderRadius: "16px",
                padding: "25px",
                boxShadow: "0 8px 30px rgba(0,0,0,0.08)",
                display: "flex",
                alignItems: "center",
                gap: "20px",
                border: "1px solid rgba(9,187,175,0.1)",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-5px)";
                e.currentTarget.style.boxShadow = "0 12px 35px rgba(0,0,0,0.12)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 8px 30px rgba(0,0,0,0.08)";
              }}
            >
              <div style={{ position: "relative", flexShrink: 0 }}>
                <img
                  src={doc.image}
                  alt={doc.name}
                  style={{
                    width: "95px",
                    height: "95px",
                    borderRadius: "50%",
                    objectFit: "cover",
                    border: "3px solid #09bbaf",
                    backgroundColor: "#f8f8f8",
                  }}
                />
                {doc.online && (
                  <span
                    style={{
                      position: "absolute",
                      bottom: "8px",
                      right: "8px",
                      width: "14px",
                      height: "14px",
                      backgroundColor: "#09bbaf",
                      borderRadius: "50%",
                      border: "2px solid #fff",
                    }}
                    title="Online"
                  ></span>
                )}
              </div>

              <div style={{ flex: 1 }}>
                <h3 style={{ fontSize: "18px", fontWeight: "700", color: "#0b1c39", marginBottom: "6px" }}>
                  {doc.name}
                </h3>
                <p style={{ color: "#09bbaf", fontSize: "14px", marginBottom: "6px", fontWeight: "600" }}>
                  {doc.specialization}
                </p>
                <p style={{ color: "#555", fontSize: "14px", marginBottom: "6px" }}>
                  {doc.qualification}
                </p>
                <p style={{ fontWeight: "600", color: "#09bbaf", marginBottom: "6px", fontSize: "15px" }}>
                  {doc.fee}
                </p>
                <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "6px" }}>
                  <span style={{ fontSize: "14px", color: "#555" }}>⭐ {doc.rating}</span>
                  <span style={{ fontSize: "14px", color: "#555" }}>{doc.experience}</span>
                </div>
                <p style={{ fontSize: "13px", color: "#555", display: "flex", alignItems: "flex-start", gap: "6px", marginBottom: "6px", lineHeight: "1.4" }}>
                  📍 {doc.location}
                </p>
                <p style={{ fontSize: "13px", color: "#555", marginBottom: "15px" }}>
                  📞 {doc.phone}
                </p>

                <button
                  style={{
                    padding: "12px 20px",
                    border: "none",
                    borderRadius: "30px",
                    backgroundColor: "#ffcb24",
                    color: "#0b1c39",
                    cursor: "pointer",
                    width: "100%",
                    fontWeight: "600",
                    fontSize: "14px",
                    transition: "background-color 0.3s ease",
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#ffd84f")}
                  onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#ffcb24")}
                >
                  Book Free Consultation
                </button>
              </div>
            </div>
          ))}
        </div>

        {!showAll && doctorsData.length > 6 && (
          <div style={{ textAlign: "center", marginTop: "40px" }}>
            <button
              onClick={() => setShowAll(true)}
              style={{
                padding: "14px 40px",
                fontSize: "16px",
                borderRadius: "12px",
                border: "none",
                backgroundColor: "#09bbaf",
                color: "#fff",
                cursor: "pointer",
                fontWeight: "700",
                boxShadow: "0 8px 25px rgba(9,187,175,0.3)",
                transition: "background-color 0.3s ease",
              }}
              onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#0dcfc2")}
              onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#09bbaf")}
            >
              View More Doctors ▼
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

const MeniscusTearTreatment = () => {
  const [activeTab, setActiveTab] = useState("overview");

  return (
    <>
      <Header />
      <Header2 />

      {/* Hero Section */}
      <section style={{
        background: "linear-gradient(135deg, #0b1c39 0%, #09bbaf 100%)",
        padding: "160px 0 100px",
        marginTop: "56px",
        color: "white",
        textAlign: "center",
        position: "relative",
        overflow: "hidden"
      }}>
        <div className="container" style={{ position: "relative", zIndex: 2 }}>
          <h1 style={{
            fontSize: "3.5rem",
            fontWeight: "800",
            marginBottom: "20px",
            color: "white"
          }}>
            Advanced Meniscus Tear Treatment
          </h1>
          <p style={{
            fontSize: "1.3rem",
            marginBottom: "30px",
            opacity: "0.9",
            maxWidth: "700px",
            margin: "0 auto 30px",
            lineHeight: "1.6"
          }}>
            Complete Meniscus Repair with 90% Success Rate. Arthroscopic Preservation Techniques for Optimal Knee Function.
          </p>
          <div style={{ display: "flex", justifyContent: "center", gap: "20px", flexWrap: "wrap" }}>
            <button style={{
              padding: "15px 35px",
              borderRadius: "30px",
              border: "none",
              backgroundColor: "#ffcb24",
              color: "#0b1c39",
              fontWeight: "700",
              fontSize: "1.1rem",
              cursor: "pointer",
              transition: "all 0.3s ease"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#ffd84f";
              e.currentTarget.style.transform = "translateY(-2px)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "#ffcb24";
              e.currentTarget.style.transform = "translateY(0)";
            }}>
              Book Free Consultation
            </button>
            <button style={{
              padding: "15px 35px",
              borderRadius: "30px",
              border: "2px solid #ffcb24",
              backgroundColor: "transparent",
              color: "#ffcb24",
              fontWeight: "700",
              fontSize: "1.1rem",
              cursor: "pointer",
              transition: "all 0.3s ease"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#ffcb24";
              e.currentTarget.style.color = "#0b1c39";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "transparent";
              e.currentTarget.style.color = "#ffcb24";
            }}>
              Emergency Knee Care
            </button>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section style={{ backgroundColor: "#fff", padding: "60px 0", borderBottom: "1px solid #eee" }}>
        <div className="container">
          <div className="row">
            <div className="col-md-3 col-6 text-center">
              <div>
                <h2 style={{ color: "#09bbaf", fontWeight: "800", fontSize: "2.5rem", marginBottom: "10px" }}>90%</h2>
                <p style={{ color: "#0b1c39", fontWeight: "600" }}>Treatment Success Rate</p>
              </div>
            </div>
            <div className="col-md-3 col-6 text-center">
              <div>
                <h2 style={{ color: "#09bbaf", fontWeight: "800", fontSize: "2.5rem", marginBottom: "10px" }}>30-90</h2>
                <p style={{ color: "#0b1c39", fontWeight: "600" }}>Minutes Procedure Time</p>
              </div>
            </div>
            <div className="col-md-3 col-6 text-center">
              <div>
                <h2 style={{ color: "#09bbaf", fontWeight: "800", fontSize: "2.5rem", marginBottom: "10px" }}>4-12</h2>
                <p style={{ color: "#0b1c39", fontWeight: "600" }}>Weeks Full Recovery</p>
              </div>
            </div>
            <div className="col-md-3 col-6 text-center">
              <div>
                <h2 style={{ color: "#09bbaf", fontWeight: "800", fontSize: "2.5rem", marginBottom: "10px" }}>{`<2%`}</h2>
                <p style={{ color: "#0b1c39", fontWeight: "600" }}>Complication Rate</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Doctors Section */}
      <DoctorsSection />

      {/* Navigation Tabs */}
      <section style={{ backgroundColor: "#fff", padding: "40px 0", borderBottom: "1px solid #eee" }}>
        <div className="container">
          <div style={{ display: "flex", justifyContent: "center", gap: "10px", flexWrap: "wrap" }}>
            {[
              { id: "overview", label: "Overview", icon: "📋" },
              { id: "symptoms", label: "Symptoms", icon: "🔍" },
              { id: "types", label: "Tear Types", icon: "🎯" },
              { id: "treatments", label: "Treatments", icon: "🔬" },
              { id: "recovery", label: "Recovery", icon: "⚕️" },
              { id: "prevention", label: "Prevention", icon: "🔄" },
              { id: "faq", label: "FAQ", icon: "🛡️" }
            ].map(tab => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                style={{
                  padding: "12px 24px",
                  borderRadius: "25px",
                  border: "none",
                  backgroundColor: activeTab === tab.id ? "#09bbaf" : "#f8f9fa",
                  color: activeTab === tab.id ? "white" : "#555",
                  fontWeight: "600",
                  cursor: "pointer",
                  transition: "all 0.3s ease"
                }}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Main Content */}
      <div className="container" style={{ padding: "80px 15px" }}>

        {/* Comprehensive Overview */}
        <section style={{ marginBottom: "80px" }}>
          <div style={{ textAlign: "center", marginBottom: "60px" }}>
            <h2 style={{ fontSize: "36px", fontWeight: "800", color: "#0b1c39", marginBottom: "20px" }}>
              Complete Guide to <span style={{ color: "#09bbaf" }}>Meniscus Tear Treatment</span>
            </h2>
          </div>

          {/* What is Meniscus Tear */}
          <div style={{ marginBottom: "60px" }}>
            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "50px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
              border: "1px solid rgba(9,187,175,0.1)"
            }}>
              <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "30px" }}>
                Understanding Meniscus Tears
              </h3>
              
              <p style={{ color: "#555", lineHeight: "1.8", fontSize: "1.1rem", marginBottom: "25px" }}>
                A meniscus tear is one of the most common knee injuries that occurs when the C-shaped cartilage 
                in your knee joint gets damaged. Each knee has two menisci - medial (inner) and lateral (outer) - 
                that act as shock absorbers between your thigh bone (femur) and shin bone (tibia). These crucial 
                structures provide stability, distribute weight, and protect the knee joint from wear and tear.
              </p>

              <div className="row">
                <div className="col-md-6">
                  <div style={{
                    backgroundColor: "#f8f9fa",
                    borderRadius: "15px",
                    padding: "25px",
                    borderLeft: "4px solid #09bbaf",
                    marginBottom: "25px"
                  }}>
                    <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px" }}>Common Causes</h5>
                    <p style={{ color: "#555", margin: 0 }}>
                      Sudden twisting movements during sports, deep squatting, heavy lifting, 
                      degenerative changes with aging, and direct trauma to the knee joint.
                    </p>
                  </div>
                </div>
                <div className="col-md-6">
                  <div style={{
                    backgroundColor: "#f8f9fa",
                    borderRadius: "15px",
                    padding: "25px",
                    borderLeft: "4px solid #ffcb24",
                    marginBottom: "25px"
                  }}>
                    <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px" }}>Importance of Treatment</h5>
                    <p style={{ color: "#555", margin: 0 }}>
                      Proper treatment prevents long-term complications like arthritis, 
                      maintains knee stability, preserves joint function, and enables return to active lifestyle.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Symptoms & Signs */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Symptoms & Clinical Presentation
            </h3>

            <div className="row">
              {[
                {
                  title: "Knee Pain", 
                  description: "Sharp pain along the joint line, especially when twisting or rotating the knee",
                  details: "Often localized to inner or outer knee"
                },
                {
                  title: "Swelling & Stiffness", 
                  description: "Gradual swelling developing 24-48 hours after injury, with stiffness and limited motion",
                  details: "Inflammatory response to cartilage damage"
                },
                {
                  title: "Popping Sensation", 
                  description: "Audible or felt popping sound at the time of injury, followed by catching sensation",
                  details: "Characteristic sign of meniscus tear"
                },
                {
                  title: "Limited Motion", 
                  description: "Difficulty fully straightening or bending the knee, feeling of something blocking movement",
                  details: "Mechanical obstruction from torn fragment"
                },
                {
                  title: "Knee Locking", 
                  description: "Knee gets stuck in one position and cannot move, requiring manual manipulation",
                  details: "Indicates displaced meniscus fragment"
                },
                {
                  title: "Instability", 
                  description: "Feeling that the knee is giving way or unable to support weight properly",
                  details: "Loss of meniscus stabilizing function"
                }
              ].map((symptom, index) => (
                <div key={index} className="col-lg-4 col-md-6 mb-4">
                  <div style={{
                    backgroundColor: "#fff",
                    borderRadius: "15px",
                    padding: "25px",
                    boxShadow: "0 8px 25px rgba(0,0,0,0.08)",
                    border: "1px solid rgba(9,187,175,0.1)",
                    height: "100%",
                    transition: "transform 0.3s ease"
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.transform = "translateY(-5px)"}
                  onMouseLeave={(e) => e.currentTarget.style.transform = "translateY(0)"}>
                    <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px", fontSize: "1.2rem" }}>
                      {symptom.title}
                    </h5>
                    <p style={{ color: "#555", fontSize: "1rem", lineHeight: "1.6", marginBottom: "15px" }}>
                      {symptom.description}
                    </p>
                    <div style={{
                      backgroundColor: "#f8f9fa",
                      borderRadius: "8px",
                      padding: "12px",
                      borderLeft: "3px solid #09bbaf"
                    }}>
                      <p style={{ color: "#666", fontSize: "0.9rem", lineHeight: "1.5", margin: 0 }}>
                        {symptom.details}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Meniscus Tear Types */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Meniscus Tear Types & Classification
            </h3>

            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)"
            }}>
              <div className="row">
                {[
                  {
                    type: "Radial Tear",
                    description: "Vertical tear perpendicular to meniscus edge, common in young athletes",
                    treatment: "Often requires surgical repair for optimal healing"
                  },
                  {
                    type: "Horizontal Tear",
                    description: "Split through meniscus creating upper and lower leaflets, degenerative in nature",
                    treatment: "Partial meniscectomy or repair depending on location"
                  },
                  {
                    type: "Flap Tear",
                    description: "Piece of meniscus flaps into joint causing mechanical symptoms",
                    treatment: "Arthroscopic debridement to remove unstable fragment"
                  },
                  {
                    type: "Bucket-Handle Tear",
                    description: "Large vertical tear that displaces into joint center, causing locking",
                    treatment: "Urgent surgical repair to preserve meniscus"
                  },
                  {
                    type: "Degenerative Tear",
                    description: "Complex tearing pattern in older patients due to cartilage wear",
                    treatment: "Conservative management or partial meniscectomy"
                  },
                  {
                    type: "Complex Tear",
                    description: "Combination of multiple tear patterns in different directions",
                    treatment: "Individualized approach based on tear configuration"
                  }
                ].map((type, index) => (
                  <div key={index} className="col-lg-6 mb-4">
                    <div style={{
                      backgroundColor: "#f8f9fa",
                      borderRadius: "15px",
                      padding: "25px",
                      border: "2px solid #09bbaf",
                      height: "100%"
                    }}>
                      <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px", fontSize: "1.2rem" }}>
                        {type.type}
                      </h5>
                      <p style={{ color: "#555", fontSize: "1rem", lineHeight: "1.6", marginBottom: "15px" }}>
                        {type.description}
                      </p>
                      <div style={{
                        backgroundColor: "#09bbaf",
                        color: "white",
                        padding: "8px 15px",
                        borderRadius: "20px",
                        display: "inline-block",
                        fontSize: "0.9rem",
                        fontWeight: "600"
                      }}>
                        {type.treatment}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Causes & Risk Factors */}
          <div style={{ marginBottom: "60px" }}>
            <div style={{
              backgroundColor: "#0b1c39",
              borderRadius: "20px",
              padding: "50px",
              color: "white"
            }}>
              <h3 style={{ fontSize: "28px", fontWeight: "800", marginBottom: "30px", color: "#ffcb24" }}>
                Causes & Risk Factors
              </h3>
              
              <div className="row">
                <div className="col-md-6">
                  <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ color: "#ffcb24", fontWeight: "700", marginBottom: "15px" }}>Primary Causes</h5>
                    <ul style={{ color: "rgba(255,255,255,0.9)", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Sudden twisting or pivoting movements</li>
                      <li style={{ marginBottom: "10px" }}>Deep squatting or kneeling with weight</li>
                      <li style={{ marginBottom: "10px" }}>Direct impact or trauma to the knee</li>
                      <li style={{ marginBottom: "10px" }}>Lifting heavy objects with improper technique</li>
                      <li>Rapid deceleration during sports activities</li>
                    </ul>
                  </div>
                </div>
                <div className="col-md-6">
                  <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ color: "#ffcb24", fontWeight: "700", marginBottom: "15px" }}>Risk Factors</h5>
                    <ul style={{ color: "rgba(255,255,255,0.9)", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Participation in contact sports (football, soccer)</li>
                      <li style={{ marginBottom: "10px" }}>Age-related degenerative changes (over 40)</li>
                      <li style={{ marginBottom: "10px" }}>Obesity and excess body weight</li>
                      <li style={{ marginBottom: "10px" }}>Previous knee injuries or surgeries</li>
                      <li>Occupations requiring kneeling or squatting</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Treatment Options */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Comprehensive Treatment Approaches
            </h3>

            <div className="row">
              <div className="col-lg-6 mb-4">
                <div style={{
                  backgroundColor: "#fff",
                  borderRadius: "20px",
                  padding: "40px",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
                  border: "2px solid #09bbaf",
                  height: "100%"
                }}>
                  <h4 style={{ color: "#0b1c39", marginBottom: "25px", fontSize: "24px", fontWeight: "800" }}>
                    Non-Surgical Management
                  </h4>
                  
                  <p style={{ color: "#555", lineHeight: "1.8", marginBottom: "25px" }}>
                    Conservative treatments are often effective for stable, degenerative, or small meniscus tears 
                    that don't cause mechanical symptoms. These approaches focus on reducing inflammation, 
                    managing pain, and restoring function through rehabilitation.
                  </p>

                  <div style={{ marginBottom: "25px" }}>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Conservative Treatments:</h6>
                    <div className="row">
                      <div className="col-6">
                        <ul style={{ color: "#555", paddingLeft: "20px", fontSize: "0.95rem" }}>
                          <li style={{ marginBottom: "8px" }}>RICE protocol (Rest, Ice, Compression, Elevation)</li>
                          <li style={{ marginBottom: "8px" }}>Physical therapy and rehabilitation</li>
                          <li style={{ marginBottom: "8px" }}>Anti-inflammatory medications</li>
                          <li style={{ marginBottom: "8px" }}>Activity modification</li>
                        </ul>
                      </div>
                      <div className="col-6">
                        <ul style={{ color: "#555", paddingLeft: "20px", fontSize: "0.95rem" }}>
                          <li style={{ marginBottom: "8px" }}>Corticosteroid injections</li>
                          <li style={{ marginBottom: "8px" }}>Bracing for stability</li>
                          <li style={{ marginBottom: "8px" }}>Weight management</li>
                          <li style={{ marginBottom: "8px" }}>Assistive devices (crutches)</li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <div>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Success Factors:</h6>
                    <ul style={{ color: "#555", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "8px" }}>60-80% success for degenerative tears</li>
                      <li style={{ marginBottom: "8px" }}>Better outcomes in older patients</li>
                      <li style={{ marginBottom: "8px" }}>Requires 4-6 weeks of dedicated therapy</li>
                      <li>Prevents unnecessary surgery in appropriate cases</li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="col-lg-6 mb-4">
                <div style={{
                  backgroundColor: "#fff",
                  borderRadius: "20px",
                  padding: "40px",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
                  border: "2px solid #ffcb24",
                  height: "100%"
                }}>
                  <h4 style={{ color: "#0b1c39", marginBottom: "25px", fontSize: "24px", fontWeight: "800" }}>
                    Surgical Treatment Options
                  </h4>

                  <div style={{ marginBottom: "25px" }}>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Surgical Procedures:</h6>
                    <ul style={{ color: "#555", paddingLeft: "20px", marginBottom: "25px" }}>
                      <li style={{ marginBottom: "10px" }}><strong>Meniscus Repair:</strong> Suturing torn edges for biological healing</li>
                      <li style={{ marginBottom: "10px" }}><strong>Partial Meniscectomy:</strong> Removing damaged portion while preserving healthy tissue</li>
                      <li style={{ marginBottom: "10px" }}><strong>Meniscus Transplantation:</strong> Donor meniscus for extensive damage</li>
                      <li style={{ marginBottom: "10px" }}><strong>Arthroscopic Surgery:</strong> Minimally invasive approach with small incisions</li>
                      <li><strong>Enhanced Repair Techniques:</strong> Bio-scaffolds and growth factors</li>
                    </ul>
                  </div>

                  <div style={{ marginBottom: "25px" }}>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Surgical Benefits:</h6>
                    <ul style={{ color: "#555", paddingLeft: "20px", marginBottom: "25px" }}>
                      <li style={{ marginBottom: "10px" }}>90% success rate for appropriate tears</li>
                      <li style={{ marginBottom: "10px" }}>Preservation of knee joint function</li>
                      <li style={{ marginBottom: "10px" }}>Prevention of early arthritis development</li>
                      <li style={{ marginBottom: "10px" }}>Return to sports and high-level activities</li>
                      <li>Long-term joint preservation</li>
                    </ul>
                  </div>

                  <div>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Advanced Techniques:</h6>
                    <ul style={{ color: "#555", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>All-inside repair devices for minimal invasion</li>
                      <li style={{ marginBottom: "10px" }}>Inside-out and outside-in suturing techniques</li>
                      <li>Meniscal root repair for critical stability</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Recovery Timeline */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Treatment & Recovery Timeline
            </h3>

            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)"
            }}>
              <div className="row">
                {[
                  {
                    period: "Week 1-2",
                    title: "Initial Recovery",
                    activities: ["Pain management", "Wound care", "Limited weight bearing", "Early range of motion"]
                  },
                  {
                    period: "Week 3-6",
                    title: "Rehabilitation Phase",
                    activities: ["Physical therapy begins", "Gradual strengthening", "Improved mobility", "Reduced swelling"]
                  },
                  {
                    period: "Month 2-3",
                    title: "Functional Recovery",
                    activities: ["Return to daily activities", "Light exercise", "Improved strength", "Normal walking"]
                  },
                  {
                    period: "Month 4-6",
                    title: "Full Recovery",
                    activities: ["Sports-specific training", "Full strength return", "High-impact activities", "Optimal function"]
                  }
                ].map((stage, index) => (
                  <div key={index} className="col-lg-3 col-md-6 mb-4">
                    <div style={{
                      backgroundColor: "#f8f9fa",
                      borderRadius: "15px",
                      padding: "25px",
                      textAlign: "center",
                      border: "1px solid rgba(9,187,175,0.2)",
                      height: "100%"
                    }}>
                      <div style={{ 
                        backgroundColor: "#09bbaf", 
                        color: "white", 
                        width: "60px", 
                        height: "60px", 
                        borderRadius: "50%", 
                        display: "flex", 
                        alignItems: "center", 
                        justifyContent: "center", 
                        margin: "0 auto 15px",
                        fontWeight: "700",
                        fontSize: "0.9rem"
                      }}>
                        {stage.period}
                      </div>
                      <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px", fontSize: "1.1rem" }}>
                        {stage.title}
                      </h5>
                      <ul style={{ color: "#555", fontSize: "0.85rem", paddingLeft: "15px", textAlign: "left" }}>
                        {stage.activities.map((activity, idx) => (
                          <li key={idx} style={{ marginBottom: "8px" }}>{activity}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Prevention & Aftercare */}
          <div style={{ marginBottom: "60px" }}>
            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
              border: "2px solid rgba(255,203,36,0.3)"
            }}>
              <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "30px", textAlign: "center" }}>
                Prevention & Post-treatment Care
              </h3>

              <div className="row">
                <div className="col-md-6">
                  <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Prevention Strategies</h5>
                    <ul style={{ color: "#555", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Maintain strong thigh and hip muscles</li>
                      <li style={{ marginBottom: "10px" }}>Use proper techniques during sports and exercise</li>
                      <li style={{ marginBottom: "10px" }}>Wear appropriate footwear for activities</li>
                      <li>Gradually increase activity intensity and duration</li>
                    </ul>
                  </div>
                </div>
                <div className="col-md-6">
                  <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Post-treatment Care</h5>
                    <ul style={{ color: "#555", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Follow prescribed physical therapy program diligently</li>
                      <li style={{ marginBottom: "10px" }}>Gradually return to activities as guided by your surgeon</li>
                      <li style={{ marginBottom: "10px" }}>Attend all follow-up appointments for monitoring</li>
                      <li>Maintain knee strength and flexibility long-term</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* FAQ Section */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Frequently Asked Questions
            </h3>

            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)"
            }}>
              {[
                {
                  question: "How painful is meniscus tear surgery?",
                  answer: "Meniscus tear surgery is typically performed arthroscopically, which is minimally invasive and results in less post-operative pain compared to open surgery. The procedure is done under anesthesia, so you won't feel pain during the surgery. After the procedure, most patients experience moderate discomfort that is well-controlled with prescription pain medication for the first 2-3 days. The pain is usually described as a deep ache rather than sharp pain, and it significantly improves within the first week. Many patients are able to manage their pain with over-the-counter medications after the first few days. The small incisions (usually 2-3, each about 1 cm long) heal quickly with minimal discomfort. Most patients report that the relief from their pre-surgery meniscus symptoms makes the temporary surgical discomfort well worth it."
                },
                {
                  question: "How long does it take to recover from meniscus surgery?",
                  answer: "Recovery time from meniscus surgery depends on the type of procedure performed: Meniscus Repair: 3-6 months for full recovery, with crutches for 4-6 weeks; Partial Meniscectomy: 4-8 weeks for full recovery, with quicker return to activities; Meniscus Transplant: 6-9 months for complete rehabilitation. For arthroscopic partial meniscectomy, most patients can return to desk work within 1-2 weeks and light activities within 3-4 weeks. For meniscus repair, the recovery is longer to allow for healing - typically 4-6 weeks on crutches with limited weight-bearing. Return to sports varies from 3-6 months depending on the sport and level of competition. Physical therapy is crucial and typically begins within 1-2 weeks after surgery. The complete recovery timeline is individualized based on the specific tear, surgical procedure, patient's age, and rehabilitation compliance."
                },
                {
                  question: "What is the success rate of meniscus tear surgery?",
                  answer: "Meniscus surgery has excellent success rates when performed for appropriate indications: Partial Meniscectomy: 85-90% success rate for pain relief and functional improvement; Meniscus Repair: 80-90% healing rate for suitable tears in well-vascularized zones; Meniscus Transplant: 75-85% success rate for pain relief and functional improvement. Success is measured by: Significant pain reduction; Improved knee function and mobility; Return to desired activities; Patient satisfaction with outcomes; Prevention of further joint degeneration. Factors that influence success include: Tear location and pattern; Patient's age and activity level; Quality of the meniscus tissue; Surgical technique and experience; Compliance with rehabilitation. Modern arthroscopic techniques and advanced repair methods have significantly improved success rates compared to historical approaches."
                },
                {
                  question: "Can a meniscus tear heal on its own without surgery?",
                  answer: "Some meniscus tears can heal without surgery, depending on several factors: Tear Location: Tears in the outer third (red zone) have blood supply and may heal; Tear Size: Small, stable tears (less than 1 cm) may heal conservatively; Tear Type: Degenerative tears in older patients often respond well to non-surgical care; Symptoms: Tears without mechanical symptoms (locking, catching) may not require surgery. Conservative treatment typically involves: Rest and activity modification; Physical therapy for strengthening; Anti-inflammatory medications; Possibly corticosteroid injections. However, certain tears require surgical intervention: Large tears causing mechanical symptoms; Displaced tears (bucket-handle tears); Tears in young, active patients; Tears associated with significant instability. About 60-70% of degenerative tears and 30-40% of traumatic tears may heal with conservative care. An orthopedic specialist can determine if your specific tear is likely to heal without surgery through physical examination and MRI evaluation."
                },
                {
                  question: "What's the difference between meniscus repair and meniscectomy?",
                  answer: "Meniscus repair and meniscectomy are two different surgical approaches with distinct goals and outcomes: Meniscus Repair involves suturing the torn edges together to preserve the meniscus tissue. It's preferred when possible because it maintains the meniscus's shock-absorbing function and protects against future arthritis. However, it requires a longer recovery with restricted weight-bearing. Meniscectomy involves removing the damaged portion of the meniscus. It provides quicker recovery but removes protective cartilage, which may increase long-term arthritis risk. Key differences include: Tissue Preservation (repair saves tissue, meniscectomy removes it); Recovery Time (repair: 3-6 months, meniscectomy: 4-8 weeks); Success Criteria (repair: biological healing, meniscectomy: symptom relief); Long-term Outcomes (repair better for joint preservation). The choice between procedures depends on tear characteristics, patient factors, and surgical findings. Your surgeon will recommend the best approach based on your specific situation to optimize both short-term recovery and long-term joint health."
                }
              ].map((faq, index) => (
                <div key={index} style={{ 
                  marginBottom: "25px",
                  paddingBottom: "25px",
                  borderBottom: index < 4 ? "1px solid #eee" : "none"
                }}>
                  <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "10px" }}>
                    {faq.question}
                  </h5>
                  <p style={{ color: "#555", lineHeight: "1.6", margin: 0 }}>
                    {faq.answer}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* Final CTA */}
          <div style={{
            background: "linear-gradient(135deg, #0b1c39 0%, #09bbaf 100%)",
            borderRadius: "20px",
            padding: "60px 40px",
            textAlign: "center",
            color: "white"
          }}>
            <h2 style={{ fontSize: "2.5rem", fontWeight: "800", marginBottom: "20px" }}>
              Need Meniscus Tear Treatment?
            </h2>
            <p style={{ fontSize: "1.2rem", marginBottom: "30px", opacity: "0.9", maxWidth: "600px", margin: "0 auto 30px" }}>
              Our expert team provides advanced meniscus treatment with 90% success rate and personalized recovery plans.
            </p>
            <button style={{
              padding: "18px 45px",
              borderRadius: "30px",
              border: "none",
              backgroundColor: "#ffcb24",
              color: "#0b1c39",
              fontWeight: "800",
              fontSize: "1.1rem",
              cursor: "pointer",
              transition: "all 0.3s ease"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#ffd84f";
              e.currentTarget.style.transform = "translateY(-2px)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "#ffcb24";
              e.currentTarget.style.transform = "translateY(0)";
            }}>
              Book FREE Consultation Now
            </button>
            <p style={{ marginTop: "20px", fontSize: "1rem", opacity: "0.8" }}>
              Orthopedics: <strong>080-6541-7705</strong> | Sports Medicine: <strong>080-6541-7715</strong>
            </p>
          </div>
        </section>
      </div>

      <Footer />
    </>
  );
};

export default MeniscusTearTreatment;